import { ActionTree } from "vuex"

import { RootState } from "~/store"

export const actions: ActionTree<any, RootState> = {
  FETCH(): Promise<void> {
    return new Promise((resolve) => {
      this.$axios.$get("/auth/csrf/")
      this.$axios.$get("/za/warudo/").finally(() => {
        resolve()
      })
    })
  },
}
